import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useAppContext } from "../libs/contextLib";
import { onError } from "../libs/errorLib";
import { API } from "aws-amplify";
import { v4 as uuidv4 } from "uuid";
import CustomTabs from "../components/CustomTabs2";
import Lookups from "../components/Lookups";
import Prompts from "../components/Prompts";
import { Box } from "@mui/material";


export default function Managemant(props) {
    const history = useHistory();
    const [tabIdx, setTabIdx] = useState(0);
    const { isAuthenticated } = useAppContext();

    const [lookups, setLookups] = useState([]);

    const [tabs, setTabs] = useState([
        { id: 1, title: "Lookups", component: Lookups, subtitle: "" },
        { id: 2, title: "Prompts", component: Prompts, subtitle: "" },
        /*{ id: 3, title: "OpenAI Config", component: "", subtitle: "" },*/
    ]);

    const renderTabContent = () => {
        const tab = tabs[tabIdx];
        const TabComponent = tab.component;
        return <TabComponent lookups={lookups} saveLookup={saveLookup} deleteLookup={deleteLookup} />;
    };
    useEffect(() => {
        onLoad();
    }, []);

    async function deleteLookup(lookup) {
        const body = { pk: "LOOKUP", sk: `${lookup.lookupName}`, mode: "delete" };
        const result = await loadLookups(body);
        await getLookups();
    }

    async function saveLookup(id, data) {
        console.log(id);
        console.log(data);
        let newId = id;
        let mode = "create";
        if (id) {
            // UPDATE EXISTING
            mode = "update";
            setLookups((prev) =>
                prev.map((item) =>
                    item.id === id
                        ? {
                            ...item,
                            lookupName: data.lookupName,
                            assetTypeCode: data.assetTypeCode,
                            data, // store full JSON
                        }
                        : item
                )
            );

        } else {
            // CREATE NEW (either new save or "save as copy")

            newId = uuidv4();

            const newItem = {
                id: newId,
                lookupName: data.lookupName,
                assetTypeCode: data.assetTypeCode,
                data,
            };


            setLookups((prev) => [...prev, newItem]);
            // optional: you could also keep track of "current selected id" in parent
            // and pass it down to Lookups if you want the new one auto-selected

        }



        const result = await uploadLookup({ id: newId, typeId: data.assetTypeCode, title: data.lookupName, json: data , mode});
    }

    function uploadLookup(body) {
        console.log(body);
        return API.post("findigai", "/lookups", {
            body: body
        })
    }


    function loadLookups(body) {
        return API.post("findigai", "/results/mode", {
            body: body
        })
    }

    async function onLoad() {
        if (!isAuthenticated) { history.push("/"); return; }
        await getLookups();
    }
    async function getLookups() {
        const body = { pk: "LOOKUP", sk: "", mode: "query" };
        const result = await loadLookups(body);
        console.log(result.data);
        if (result.status && result.data) {
            console.log(result.data);

            const loadedLookups = result.data
                .filter(item => item.content)
                .map(item => ({
                    id: item.itemId,
                    lookupName: item.content.lookupName,
                    assetTypeCode: item.content.assetTypeCode,
                    data: item.content,
                }));

            setLookups(loadedLookups);
        }
    }

    function handleTabChange(event, value) {
        event.preventDefault();
        console.log(value);
        setTabIdx(value);
    };

    function renderLander() {
        return (
            <Box p={0} sx={{ backgroundColor: "#fff" }}>
                <Box px={1} sx={{
                    width: '100%',
                    bgcolor: 'white',
                    color: 'white',
                }}>
                    <CustomTabs
                        tabs={tabs}
                        value={tabIdx}
                        onChange={handleTabChange}
                    />
                    <Box p={2} sx={{
                        width: '100%',
                        bgcolor: '#33337733',
                        color: '#330',
                    }}>
                        {renderTabContent()}
                    </Box>
                    <Box p={2} sx={{
                        width: '100%',
                        bgcolor: 'white',
                        color: 'white',
                    }}>
                    </Box>
                </Box>

            </Box>

        )
    }
    return (
        <>
            {renderLander()}
        </>
    )
}